import { EarbudsOffOutlineIcon } from './EarbudsOffOutlineIcon';

/**
 * author: Colton Wiscombe
 * id E9DB591B-AB1E-4C5B-9596-63EA899D54AF
 * name earbuds-off-outline
 * version: 6.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/earbuds-off-outline.svg
 * tags
 * - Audio 
 * - Music 
 */
export const HeadphonesOffOutlineIcon = EarbudsOffOutlineIcon;
export default HeadphonesOffOutlineIcon